<template>
  <WidgetPanel>
    <template #header>
      <h3 class="text-lg leading-6 font-medium text-gray-900">
        Dauerhaft angewandt
      </h3>
    </template>
    <template #default>
      <div v-if="empty" class="divide-y divide-gray-200">
        <div class="block hover:bg-gray-50">
          <div class="min-w-0 flex-1 flex items-center">
            <div class="flex items-center px-4 py-4 sm:px-6">
              <div class="min-w-0 flex-1 flex items-center">
                <p class="text-sm font-medium text-gray-600 truncate">
                  Öffne eine Methode und markiere sie oben rechts mit „In Anwendung“
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ul role="list" class="divide-y divide-gray-200">
        <AppliedWidgetItem  v-for="a in results" :key="a.id" :application="a" as="li" />
      </ul>
    </template>
  </WidgetPanel>
</template>

<script setup>
import { computed, onMounted, watch } from 'vue';
import { useFetchResources } from '@/client/actions';

const props = defineProps({podcast: Object});
const parent = computed(() => props.podcast.id);
const target = computed(() => '/api/podcasts/' + parent.value + '/applications');
const action = useFetchResources(target);

const { results, fetch, empty } = action;

const watcher = watch(target, (v, _) => fetch());
const mounted = onMounted(() => fetch());
</script>

